(function (global, factory) {
  if (typeof module === "object" && typeof module.exports === "object") {
    module.exports = factory(global);
  } else {
    factory(global);
  }
})(typeof window !== "undefined" ? window : this, function (window) {
  const InfiniteScroll = function (options) {
    this.settings = Object.assign(
      {
        productGridSelector: "#product-grid",
        nextPageLinkSelector: "#next-page-link",
        loadingSpinnerSelector: "#loading-spinner",
        threshold: 400,
      },
      options
    );

    this.productGrid = document.querySelector(this.settings.productGridSelector);
    this.nextPageLink = document.querySelector(this.settings.nextPageLinkSelector);
    this.loadingSpinner = document.querySelector(this.settings.loadingSpinnerSelector);
    this.threshold = this.settings.threshold;
    this.isLoading = false;

    if (this.productGrid && this.nextPageLink) {
      this.init();
    }
  };

  InfiniteScroll.prototype.init = function () {
    window.addEventListener("scroll", this.onScroll.bind(this));
  };

  InfiniteScroll.prototype.onScroll = function () {
    const scrollHeight = document.documentElement.scrollHeight;
    const scrollTop = document.documentElement.scrollTop;
    const clientHeight = document.documentElement.clientHeight;

    if (scrollTop + clientHeight >= scrollHeight - this.threshold && this.nextPageLink) {
      this.loadMoreProducts();
    }
  };

  InfiniteScroll.prototype.loadMoreProducts = function () {
    if (this.isLoading || !this.nextPageLink) return;

    this.isLoading = true;
    if (this.loadingSpinner) this.loadingSpinner.classList.remove("hidden");

    const nextPageUrl = this.nextPageLink.href;

    fetch(nextPageUrl)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProducts = doc.querySelector(this.settings.productGridSelector).innerHTML;
        this.productGrid.insertAdjacentHTML("beforeend", newProducts);

        const updatedNextPageLink = doc.querySelector(this.settings.nextPageLinkSelector);
        if (updatedNextPageLink) {
          this.nextPageLink.href = updatedNextPageLink.href;
          this.nextPageLink.setAttribute("data-next-page", updatedNextPageLink.getAttribute("data-next-page"));
        } else {
          this.stopInfiniteScroll();
        }

        this.isLoading = false;
        if (this.loadingSpinner) this.loadingSpinner.classList.add("hidden");
      })
      .catch((error) => {
        console.error("Error loading more products:", error);
        this.isLoading = false;
        if (this.loadingSpinner) this.loadingSpinner.classList.add("hidden");
      });
  };

  InfiniteScroll.prototype.stopInfiniteScroll = function () {
    window.removeEventListener("scroll", this.onScroll.bind(this));
    this.nextPageLink = null;
    console.log("Infinite Scroll stopped. No more pages to load.");
  };

  // Expose the plugin to the global scope
  window.InfiniteScroll = InfiniteScroll;
});
